import { render, staticRenderFns } from "./ContentRendererLoading.vue?vue&type=template&id=4a649fcc"
import script from "./ContentRendererLoading.vue?vue&type=script&lang=js"
export * from "./ContentRendererLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports